import { useForm } from "react-hook-form";

export type EditAssignmentFormValues = {
  assigned_at: string;
  ended_at:    string;
  is_active:   boolean;
  notes:       string;
};

const DEFAULTS: EditAssignmentFormValues = {
  assigned_at: "",
  ended_at:    "",
  is_active:   true,
  notes:       "",
};

export function useEditAssignmentForm() {
  return useForm<EditAssignmentFormValues>({ defaultValues: DEFAULTS });
}
